import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';
import ContextHelpText from './ContextHelpText';

export default class CardProfilesPageHelp extends React.PureComponent {
  render() {
    const {department, hasDepartmentContext, cardProfiles} = this.props;
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>
          Users can fill out a scorecard on any call that they have access to by choosing the
          "Scorecard" button on the call player card.
        </p>
        <p>
          A scorecard profile groups together scorecards which are shown as options for a given
          department's calls. For example, your Customer Success department may have a different set
          of scorecards from your Inside Sales department.
        </p>
        {hasDepartmentContext && department ? (
          <ContextHelpText
            department={department}
            profiles={cardProfiles}
            profileName="Scorecard"
          />
        ) : (
          <p>Click New Scorecard Profile to configure a new profile.</p>
        )}
      </HelpLink>
    );
  }
}
